import styled from 'styled-components';
import { Markdown as MarkdownDisplay } from '../markdown';
import { paragraph, spacedHeading } from '../../../theme/typography';
import { Button } from '../button';
import { Content } from '../../../theme/layout';
import { media } from '../../../theme/media';

export const ContentWrapper = styled(Content)`
  padding-top: 56px;
  padding-bottom: 104px;
  ${media.tablet`
    padding-bottom: 80px;
  `}
  padding-bottom: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const UnderstandButton = styled(Button)`
  margin-top: 56px;
  ${media.tablet`
    margin-top: 64px;
  `}
  max-width: 700px;
`;

export const Title = styled.h1`
  ${spacedHeading};
`;

export const Markdown = styled(MarkdownDisplay)`
  ${paragraph};
  max-width: 636px;
  text-align: left;
`;
